import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import iconDraw from '../../../assets/images/ad/draw.webp';
import iconFirst from '../../../assets/images/ad/first.webp';
import iconGalery from '../../../assets/images/ad/gallery.webp';
import iconGroup from '../../../assets/images/ad/group.webp';
import iconHalal from '../../../assets/images/ad/halal.webp';
import iconHandshake from '../../../assets/images/ad/handshake.webp';
import iconPieChart from '../../../assets/images/ad/pie-chart.webp';
import iconSmartphone from '../../../assets/images/ad/smartphone.webp';
import logo from '../../../assets/images/logo_mrh_transparent.webp';
import screensIMAGE from '../../../assets/images/screensIMAGE.webp';
import { Typography } from '@/components/atoms/Typography';
import { ImageBlocks } from '@/components/molecules/ImageBlocks';

type MRHInfosProps = {
  containerClassName?: string;
};

export const MRHInfos: React.FC<MRHInfosProps> = ({ containerClassName }: MRHInfosProps) => {
  const { t } = useTranslation();

  const IMAGES = [
    {
      src: iconHalal
    }
  ];

  const WHYMRH_IMAGES = [
    {
      title: t('promotion.whyMRH.item1'),
      src: iconFirst
    },
    {
      title: t('promotion.whyMRH.item2'),
      src: iconGroup
    },
    {
      title: t('promotion.whyMRH.item3'),
      src: iconHandshake
    },
    {
      title: t('promotion.whyMRH.item4'),
      src: iconSmartphone
    }
  ];

  const ESPACES_IMAGES = [
    {
      title: 'Apparaîssez sur MonRestoHalal',
      src: logo
    },
    {
      title: 'Visualisez vos statistiques',
      src: iconPieChart
    },
    {
      title: 'Éditez votre fiche restaurant',
      src: iconDraw
    },
    {
      title: 'Ajoutez vos photos',
      src: iconGalery
    },
    {
      title: 'Ajoutez votre certificat halal',
      src: iconHalal
    }
  ];

  return (
    <section className={classNames(containerClassName, 'space-y-5 bg-white overflow-auto pt-10 rounded-[calc(2rem+1px)] shadow ring-1 ring-black/5')}>
      <section className="flex flex-col gap-5 py-10">
        <span className="flex flex-col gap-2 px-5 md:px-0">
          <div className="flex items-end justify-center gap-2">
            <Typography tag="p" variant="h2" weight="medium" align="center">
              Apparaissez sur MonResto'Halal pour
            </Typography>
            <Typography tag="p" variant="h1" weight="bold" align="center">
              0€
            </Typography>
          </div>
          <Typography tag="p" variant="h4" align="center" color="gray">
            accédez à votre espace et référencez votre restaurant gratuitement
          </Typography>
        </span>
        <img src={screensIMAGE} alt="screen stats" className="w-full rounded-md h-full object-contain" />
        <ImageBlocks margin={false} images={ESPACES_IMAGES} bgClassName="bg-gray-200 border-gray-500" />
      </section>

      <div className="bg-gray-300 h-[2px] w-full" />

      <section className="flex flex-col gap-10 py-10">
        <span className="flex flex-col gap-2 px-5 md:px-0">
          <Typography tag="p" variant="h2" weight="bold" align="center">
            Pourquoi se référencer ?
          </Typography>
          <Typography tag="p" variant="h3" align="center" color="gray">
            {t('promotion.whyMRH.subtitle')}
          </Typography>
        </span>
        <ImageBlocks margin={false} images={WHYMRH_IMAGES} bgClassName="bg-primary border-primary" />
      </section>

      <section className=" gap-5 py-12 bg-black items-center grid grid-cols-5">
        <div className="flex col-span-3 flex-col gap-2 px-5 md:px-0">
          <Typography tag="p" variant="h2" weight="bold" align="center" color="white">
            Conditions d'éligibilité
          </Typography>
          <Typography tag="p" variant="h5" align="center" color="white">
            Servir uniquement de la viande halal
          </Typography>
        </div>

        <div className="col-span-2">
          <ImageBlocks margin={false} images={IMAGES} color="white" bgClassName=" bg-yellow-100 border-yellow-700" />
        </div>
      </section>
    </section>
  );
};
